/* eslint-disable */
import { useContext } from "react";

import { LocalizationContext } from "../../App";
import { Formatters } from "../../common/helpers/formatters";
import { Claim } from "../../models/claim";
import { ClaimStatusDefinition } from "../../models/claimStatusDefinition";
import StatusIndicator from "../common/StatusIndicator";

type ClaimCardProps = {
  claim: Claim;
  claimStatusDefinition?: ClaimStatusDefinition;
};

export const ClaimCard = ({ claim, claimStatusDefinition }: ClaimCardProps) => {
  const l10n = useContext(LocalizationContext);
  const status = claimStatusDefinition && claimStatusDefinition.statusDefinition[claim.statusId];
  const subStatus = claimStatusDefinition?.subStatusDefinition?.find(
    (ss) => ss.code === claim.subStatusId
  )?.name;

  return (
    <div className="card">
      <div className="card-header pb-2">{claim.claimNumber}</div>
      <div className="card-body pt-2">
        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col">
            <span className="text-sm overflow-hidden text-ellipsis whitespace-nowrap">
              {l10n.label.policyNumber}
            </span>
            <span className="font-semibold break-words hyphens-manual whitespace-normal">
              {claim.policyNumber}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="text-sm overflow-hidden text-ellipsis whitespace-nowrap">
              {l10n.label.incidentDate}
            </span>
            <span className="font-semibold whitespace-normal">
              {Formatters.formatShortDate(claim.incidentDate) ?? "N/A"}
            </span>
          </div>

          {status && (
            <div className="flex flex-col">
              <span className="text-sm overflow-hidden text-ellipsis whitespace-nowrap">
                {l10n.label.status}
              </span>
              <span className="font-semibold text-ellipsis whitespace-nowrap">
                <StatusIndicator
                  status={claim.statusId <= 2 ? "pending" : "success"}
                  title={claimStatusDefinition?.statusDefinition[claim.statusId]}
                />
              </span>
            </div>
          )}

          {subStatus && (
            <div className="flex flex-col">
              <span className="text-sm overflow-hidden text-ellipsis whitespace-nowrap">
                {l10n.label.subStatus}
              </span>
              <span className="font-semibold">
                {claimStatusDefinition?.subStatusDefinition?.find(
                  (ss) => ss.code === claim.subStatusId
                )?.name}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
